'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var SvgIcon = require('../../library/DataDisplay/SvgIcon.js');
var iconStyles = require('../iconStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var NewMessage = function NewMessage(props) {
  return React__default["default"].createElement(SvgIcon, _objectSpread({}, props, {
    viewBox: "0 0 24 24"
  }), React__default["default"].createElement("g", null, React__default["default"].createElement("path", {
    d: "M19,19 L5,19 L5,5 L12,5 L12,3 L5,3 C3.89,3 3,3.9 3,5 L3,19 C3,20.1 3.89,21 5,21 L19,21 C20.1,21 21,20.1 21,19 L21,12 L19,12 L19,19 Z"
  }), React__default["default"].createElement("path", {
    d: "M9,12.2147198 L9,15 L11.7852802,15 L20,6.78528022 L17.2147198,4 L9,12.2147198 Z M21.8007663,4.75351213 C22.0664112,4.48786718 22.0664112,4.0587484 21.8007663,3.79310345 L20.2068966,2.19923372 C19.9412516,1.93358876 19.5121328,1.93358876 19.2464879,2.19923372 L18,3.44572158 L20.5542784,6 L21.8007663,4.75351213 Z"
  })));
};

var NewMessage$1 = iconStyles()(NewMessage);

module.exports = NewMessage$1;
